export class TestAttackFileModel {
    id = '';
    accountId = '';
    accountName = '';
    courseId = '';
    courseName = '';
    testId = '';
    testName = '';
    comment = '';
    attackLink : string | FileObject[] = '';
    isLastest: boolean | number = 0;
    isAccept: boolean | number = 0;
    point = 0;
    fileType = '';
    evaluateComment = '';
    createdDate: any = null;
    createdBy = '';
    modifiedDate: any = null;
    modifiedBy = '';
}

export class TestAttackFileAcceptModel {
    attackFiles?: FileObject[] = [];
    id: string = '';;
    evaluateComment: string = '';
    point = 0;
    isAccept = 0;
}

export class FileObject {
    id: string = '';
    name: string = '';
    size: number = 0;
    type: string = '';
    width: number = 0;
    height: number = 0;
    file: File | null = null;
    isNew: boolean = true;
    isDelete: boolean = false; // Đánh dấu file có bị xóa không => Gọi api xóa file gốc trên server
    url: string = '';
}